export const SET_REMOTE_CONFIG_START = 'SET_REMOTE_CONFIG_START';
export const SET_REMOTE_CONFIG_FINISHED = 'SET_REMOTE_CONFIG_FINISHED';
